import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { getIconForPath } from '../../../config/navigationConfig';

const PageTitle = ({ children, className }) => {
  const location = useLocation();
  const icon = getIconForPath(location.pathname);

  return (
    <TitleWrapper className={className}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <StyledTitle>{children}</StyledTitle>
    </TitleWrapper>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.brand || '#701a82'};
  font-size: 1.75rem;
  
  svg {
    width: 28px;
    height: 28px;
  }
`;

const StyledTitle = styled.h1`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.textPrimary || '#111827'};
  font-weight: 700;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export default PageTitle;
